import type { RecallKpiData } from '@services/api/dashboard/recall.api'
import type { DashboardMetricItemData } from '../types/dashboardMetrics.types'

export function mapRecallOverviewToMetrics(
  kpis: RecallKpiData,
): DashboardMetricItemData[] {
  return [
    {
      id: 'completed-recall',
      leftLabel: 'Completed recall',
      value: String(kpis.completedRecall),
      footer: `${kpis.completedDelta} ${kpis.comparisonLabel}`,
      footerTrend: kpis.completedTrend,
    },
    {
      id: 'overdue-patients-recall',
      leftLabel: 'Overdue patients',
      value: String(kpis.overduePatients),
      footer: `${kpis.overdueDelta} ${kpis.comparisonLabel}`,
      footerTrend: kpis.overdueTrend,
    },
    {
      id: 'recall-production',
      leftLabel: 'Recall production',
      value: kpis.recallProduction,
      footer: `${kpis.productionDelta} ${kpis.comparisonLabel}`,
      footerTrend: kpis.productionTrend,
    },
    {
      id: 'scheduled-recall',
      leftLabel: 'Scheduled recall',
      value: String(kpis.scheduledRecall),
    },
    {
      id: 'recall-rate',
      leftLabel: 'Recall rate',
      value: kpis.recallRate,
    },
    {
      id: 'recall-reactivation',
      leftLabel: 'Recall reactivation',
      value: kpis.recallReactivation,
    },
  ]
}
